import { combineReducers } from 'redux'
import {
  createReducer,
  createRequestReducer
} from 'pobble-components/dist/redux-helpers'
import { normalize, schema } from 'normalizr'

const normalizePupils = data => {
  const pupil = new schema.Entity(
    'pupils',
    {},
    { idAttribute: pupil => pupil.account.id }
  )
  return normalize(data, [pupil])
}

let defaultState = null

const PupilsReducer = combineReducers({
  fetching: createRequestReducer('PUPILS:FETCHING', { pending: true }),
  pupils: createReducer(defaultState, {
    'PUPILS:FETCHING_REQUEST_SUCCESS': (state, { response }) =>
      normalizePupils(response.data.school.student_types)
  })
})

export default PupilsReducer
